import { render, staticRenderFns } from "./Zcgdd.vue?vue&type=template&id=515ccdb4&scoped=true&"
import script from "./Zcgdd.vue?vue&type=script&lang=js&"
export * from "./Zcgdd.vue?vue&type=script&lang=js&"
import style0 from "./style.css?vue&type=style&index=0&id=515ccdb4&prod&scoped=true&lang=css&"
import style1 from "./Zcgdd.vue?vue&type=style&index=1&id=515ccdb4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515ccdb4",
  null
  
)

export default component.exports